import React from 'react';

interface StorylineInputViewProps {
  storyline: string;
  title: string;
  description: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  validationError: string;
  onRandomSelection: () => void;
}
// We need it to be a const component outside the page context and not just an inline function, otherwise it is fully re-initialized on state change
const StorylineInputView: React.FC<StorylineInputViewProps> = ({
  storyline,
  title,
  description,
  onChange,
  onSubmit,
  onRandomSelection,
  validationError,
}) => {
  return (
    <div className="flex-1 flex flex-col">
      <div
        className="flex justify-between items-start short:pt-1 short:pb-1 pt-4 pb-2 sticky top-0 z-10 bg-white
                max-lg:flex-col max-lg:gap-2"
      >
        <div
          className="
                  flex-col justify-start items-start gap-2 inline-flex
                  max-lg:gap-0
                "
        >
          <div className="text-xl font-semibold max-lg:text-lg">{title}</div>
          <div
            className="text-sm leading-5 max-w-[834px] text-neutral-800 text-opacity-70 text-left max-lg:hidden
                short:hidden"
          >
            {description}
          </div>
        </div>
      </div>
      <textarea
        defaultValue={storyline}
        onChange={(e) => onChange(e.target.value)}
        autoFocus
        maxLength={1500}
        placeholder="e.g., A brave hero with a heart of gold..."
        className={`
              w-full flex-1 py-2 pr-1.5 pl-3.5 text-base italic leading-6 bg-gray-50 rounded-lg my-1 border border-solid text-neutral-800 placeholder-neutral-800 placeholder-opacity-20 resize-none focus:outline-none focus:ring-2 focus:ring-blue-600
              ${validationError ? 'border-red-500' : 'border-gray-300'}
            `}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && e.ctrlKey) {
            onSubmit();
          }
        }}
      />
      {validationError && (
        <div className="text-red-500 text-sm mt-1">{validationError}</div>
      )}
    </div>
  );
};

export default StorylineInputView;
